import ProductCard from "../../components/product-card/product-card.component";

import {
  CategoryPreviewContainer,
  Preview,
  Title,
} from "./category-preview.styles";

const CategoryPreview = ({ title, products }) => (
  <CategoryPreviewContainer>
    <h2>
      <Title to={`/shop/${title}`}>{title.toUpperCase()}</Title>
    </h2>
    <Preview>
      {products
        .filter((_, idx) => idx < 4)
        .map((p) => (
          <ProductCard key={p.id} product={p} />
        ))}
    </Preview>
  </CategoryPreviewContainer>
);

export default CategoryPreview;
